module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "serviceAgreement"
  }, [_c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.infoData)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3099bfc9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/serviceAgreement.vue
// module id = 519
// module chunks = 0